/**
 * Registering the service worker, which is what makes this portal installable.
 *
 * §8 asks for a portal a cook, a waiter or a therapist opens on their own telephone. A
 * portal somebody has to find in a browser's history every morning is one they stop
 * opening, and a browser will only offer "add to home screen" for a page that registers
 * a worker — so there is one, and it caches nothing at all. `public/sw.js` says why at
 * length; the short version is that every screen here is a legal record read live, and a
 * cached answer is indistinguishable from a correct one.
 *
 * Three things this deliberately does not do:
 *
 *   - **it never throws.** A browser with no `serviceWorker` (an old handset, a private
 *     window, a page served over plain http on somebody's laptop) is an ordinary state:
 *     the portal works, it is simply not installable. A failed registration must not
 *     take the application down with it.
 *   - **it waits for `load`.** Registration competes with the first paint for the same
 *     connection otherwise, and the first paint is what somebody standing at a door is
 *     waiting for.
 *   - **it says nothing to the person.** There is no "install this" banner. The browser
 *     has one of its own and knows when to show it; ours would be a thing to dismiss on
 *     every screen of a portal opened for ten seconds at a time.
 */
export const registerServiceWorker = (): void => {
    if (!('serviceWorker' in navigator)) return

    window.addEventListener('load', () => {
        void navigator.serviceWorker.register('/sw.js').catch(() => {
            // Nothing to do and nothing to say: the portal works, it is not installable.
        })
    })
}
